import request from "../utils/request"

// 七牛云图片地址
export function getUrl(params) {
  return request({
		url: `/tour-product/imge/getUrl`,
		method: 'post',
		params
	})
}


// 获取用户基本信息
export function getUserInfo(params) {
  return request({
		url: `/tour-product/qunaerUser/getUserInfo`,
		method: 'post',
		params
	})
}

// 根据省份获取城市列表
export function getCityByProvinceList(params) {
  return request({
		url: `/tour-product/wxscenic/getCityByProvinceList`,
		method: 'post',
		params
	})
}

// 景区列表
export function queryScenicList(params) {
  return request({
		url: `/tour-product/qunaerUser/queryScenicList`,
		method: 'post',
		params
	})
}

// 景区列表（游客展示）
export function getScenicList(data) {
  return request({
		url: `/tour-product/wxscenic/getScenicListV2`,
		method: 'post',
		data
	})
}

// 景区详情
export function getScenicInfo(params) {
  return request({
		url: `/tour-product/wxscenic/getScenicInfo`,
		method: 'post',
		params
	})
}

// 预约
export function userAppointment1(params) {
  return request({
		url: `/tour-product/wxorder/userAppointment1`,
		method: 'post',
		params
	})
}

// 订单列表
export function queryByBusinessId(params) {
  return request({
		url: `/tour-product/wxorder/queryByBusinessId`,
		method: 'post',
		params
	})
}

// 取消预约
export function cancelOrder(params) {
  return request({
		url: `/tour-product/wxorder/cancelOrder`,
		method: 'post',
		params
	})
}
// 取消预约
export function getOrderInfo(params) {
  return request({
		url: `/tour-product/wxorder/getOrderInfo`,
		method: 'post',
		params
	})
}
// 发送验证码
export function sendVerifyCode(params) {
  return request({
		url: `/tour-product/qunaerUser/sendVerifyCode`,
		method: 'post',
		params
	})
}
// 完善用户信息
export function updatePhone(params) {
  return request({
		url: `/tour-product/wxusercard/updatePhone`,
		method: 'post',
		params
	})
}
// 预约说明 
export function AppointmentText(params) {
	return request({
		url: `/tour-product/wxactivity/getSysArticleInfo`,
		method: 'post',
		params
	})
}

// 完善信息
export function bindPhone(params) {
	return request({
		url: `/tour-product/qunaerUser/bindPhone`,
		method: 'post',
		params
	})
}

